import { RootState } from "@/redux/store";

export const bookingOfferSelector = (state: RootState) => state.bookingOffer.bookingOffer;
export const bookingOfferDocumentsSelector = (state: RootState) => state.bookingOffer.documents;
